import { DistributorID } from 'fym-shared/src/smartlinks/catalog';
import cdBabyLogo from 'fym-shared/src/music-services/assets/distributors/cdbaby-color.svg';
import distroKidLogo from 'fym-shared/src/music-services/assets/distributors/distrokid-light.svg';
import dittoLogo from 'fym-shared/src/music-services/assets/distributors/ditto-dark.svg';
import onerpmLogo from 'fym-shared/src/music-services/assets/distributors/onerpm-dark.svg';
import tuneCoreLogo from 'fym-shared/src/music-services/assets/distributors/tunecore-dark.svg';
import tuneCoreJapanLogo from 'fym-shared/src/music-services/assets/distributors/tunecorejapan-dark.svg';
import unitedMastersLogo from 'fym-shared/src/music-services/assets/distributors/unitedmasters-on-background.svg';

/**
 * The bundled url of each distributor logo. The files and their metadata live
 * in fym-shared (`distributorLogos`). The page loads them as `<img>`, not as
 * inline SVG: the brand files carry `<style>` blocks with generic class names
 * (`.st0`, `.cls-2`), and an inline copy would leak them into the page.
 */
export const distributorLogoUrls: Record<DistributorID, string> = {
  [DistributorID.DistroKid]: distroKidLogo,
  [DistributorID.TuneCore]: tuneCoreLogo,
  [DistributorID.CDBaby]: cdBabyLogo,
  [DistributorID.Ditto]: dittoLogo,
  [DistributorID.UnitedMasters]: unitedMastersLogo,
  [DistributorID.ONErpm]: onerpmLogo,
  [DistributorID.TuneCoreJapan]: tuneCoreJapanLogo,
};
